import { useRef, useState } from "react";
import { Upload } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
  ACCEPTED_IMAGE_TYPES,
  rejectInvalidImage,
  updateBrickCollection,
  uploadImage,
} from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  brickCollection: any | null;
  onUpdate(newCollection: any): void;
}

const UploadThumbnail: React.FC<Props> = ({ brickCollection, onUpdate }) => {
  const organization = useOrganization();
  const [loading, setLoading] = useState<boolean>(false);
  const keys = useRef<Record<string, string>>({});

  const handleFileChanged = async ({ file }: { file: any }) => {
    if (file.status === "removed") {
      await updateBrickCollection(organization, brickCollection._id, {
        thumbnail: null,
      });
      onUpdate({ ...brickCollection, thumbnail: null });
    } else if (file.status === "uploading") {
      setLoading(true);
    } else if (file.status === "error") {
      setLoading(false);
    } else if (file.status === "done") {
      const newCollection = await updateBrickCollection(
        organization,
        brickCollection._id,
        {
          thumbnail: keys.current[file.uid],
        }
      );
      setLoading(false);
      onUpdate(newCollection);
    }
  };

  const handleUpload = async ({
    onSuccess,
    onError,
    onProgress,
    file,
  }: any) => {
    try {
      keys.current[file.uid] = await uploadImage(
        brickCollection._id,
        "thumbnail",
        file,
        (percent) => onProgress({ percent }, file)
      );
      onSuccess(null, file);
    } catch (e) {
      onError(e, null, file);
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Upload
      className="thumbnail-uploader"
      accept={ACCEPTED_IMAGE_TYPES}
      beforeUpload={rejectInvalidImage}
      listType="picture-card"
      showUploadList={false}
      customRequest={(e) => handleUpload(e)}
      onChange={(e) => handleFileChanged(e)}
    >
      {brickCollection.thumbnail != null ? (
        <img
          src={brickCollection.thumbnail}
          alt="avatar"
          style={{ width: "200px", maxWidth: "100%" }}
        />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default UploadThumbnail;
